import Tooltip from "@mui/material/Tooltip";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Badge from "@mui/material/Badge";
import ListItemText from "@mui/material/ListItemText";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import ListItemButton from "@mui/material/ListItemButton";
import ReportProblem from "@mui/icons-material/ReportProblem";

export default function ActiveEquipment(props) {
  return (
    <div style={{ width: "100%" }}>
      <Typography variant="h6" color="primary" fontWeight={700}>
        Assets with the most active issues
      </Typography>
      <List sx={{ width: "100%" }} dense={true}>
        <Divider />
        {props.activeEquipmentData.map((eqp, idx) => [
          <ListItem
            key={idx}
            disableGutters
            secondaryAction={
              <IconButton
                edge="end"
                href={`/project/${props.projectId}/equipment/${eqp.id}`}
                aria-label={`Issues (${eqp.activeIssues})`}
              >
                <Tooltip
                  title={`Issues (${eqp.activeIssues})`}
                  // title={`Issues (${props.e.Checklists.length})`}
                >
                  <IconButton
                    aria-label="Issues"
                    size="large"
                    color={"primary.light"}
                  >
                    <Badge
                      badgeContent={eqp.activeIssues}
                      sx={{
                        "& .MuiBadge-badge": {
                          color: "primary.contrastText",
                          backgroundColor: "secondary.light",
                        },
                      }}
                      showZero
                    >
                      <ReportProblem fontSize="inherit" />
                    </Badge>
                  </IconButton>
                </Tooltip>
              </IconButton>
            }
          >
            <ListItemButton
              component="a"
              href={`/project/${props.projectId}/equipment/${eqp.id}`}
            >
              <ListItemText
                primary={eqp.Name}
                secondary={eqp.activeIssues + " active issues"}
              />
            </ListItemButton>
          </ListItem>,
          <Divider key={idx + 1} />,
        ])}
      </List>
    </div>
  );
}
